import DataApi from './DataApi';

/**
 * Lightweight feature flag checks (temporary rollout control).
 * Source of truth: public.system_feature_flags via backend.
 */
export async function isFeatureEnabled(featureKey) {
  const key = String(featureKey || '').trim();
  if (!key) return false;
  try {
    const api = new DataApi('features');
    const res = await api.get(`/flags/${encodeURIComponent(key)}`);
    return res?.data?.enabled === true;
  } catch {
    return false;
  }
}

